import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, Drawer, Form, Input, Select, Spin, TreeSelect } from "antd";
import PropTypes from "prop-types";

import { Modals, Types } from "scripts/settings";
import API from "scripts/api";
import Resources from "scripts/resources";
import Rules from "scripts/rules";
import { ObjectNumbersToEnglish } from "scripts/helpers";

const Component = ({ data = {}, onUpdate, options: { statuses } }) => {
	const initialState = {};
	const [state, setState] = useState(initialState);
	const { submitting, visible } = state;
	const { id } = data;
	const { hash, pathname, search } = useLocation();
	const navigate = useNavigate();
	const [form] = Form.useForm();

	const handleClose = () => {
		navigate(-1);
	};

	const handleSubmit = () => {
		if (!submitting) {
			form.validateFields().then((values) => {
				setState((prevState) => ({ ...prevState, submitting: true }));

				values = ObjectNumbersToEnglish(values);

				API.paymentVerification
					.status(id, values)
					.then(() => {
						onUpdate(null, true);
						handleClose();
					})
					.catch(() => {
						setState((prevState) => ({
							...prevState,
							submitting: false,
						}));
					});
			});
		}
	};

	const componentDidUpdate = () => {
		switch (hash) {
			case `#${Modals.CREATE}`: {
				if (id) {
					setState((prevState) => ({ ...prevState, visible: true }));
				} else {
					navigate(`${pathname}${search}`, { replace: true });
				}
				break;
			}
			default: {
				if (visible) form.resetFields();

				setState(initialState);

				break;
			}
		}
	};

	useEffect(componentDidUpdate, [hash]);

	const footer = (
		<>
			<Button type="primary" onClick={handleSubmit} loading={submitting}>
				{Resources.confirm}
			</Button>
			<Button onClick={() => handleClose()} loading={submitting}>
				{Resources.cancel}
			</Button>
		</>
	);

	return (
		<Drawer
			className="sp-form-drawer"
			footer={footer}
			onClose={() => handleClose()}
			title={`${Resources.change} ${Resources.status}`}
			maskClosable={false}
			open={visible}
			width={414}
		>
			<Form layout="vertical" form={form}>
				<Form.Item
					name="status"
					label={Resources.status}
					rules={Rules.required}
				>
					<Select options={statuses} />
				</Form.Item>
				<Form.Item name="description" label={Resources.description}>
					<Input.TextArea rows={4} />
				</Form.Item>
			</Form>
		</Drawer>
	);
};

Component.propTypes = {
	data: PropTypes.object,
	onUpdate: PropTypes.func.isRequired,
	options: PropTypes.object.isRequired,
};

export default Component;
